import React from "react"
import { Block } from "baseui/block"
import { H4, Paragraph4 } from "baseui/typography"
import { Link } from "gatsby-plugin-intl"
import { formatMessageFromData } from "../utils/intl"

export const PostDescription = ({
  title,
  description,
  fullHeight,
  horizontal,
}: any) => {
  return (
    <>
      {!fullHeight && (
        <H4
          color={"white"}
          marginTop={"0px"}
          marginBottom={fullHeight ? "0px" : ["4px", "4px", "4px", "8px"]}
          overrides={{
            Block: {
              style: ({ $theme }) => ({
                whiteSpace: "normal",
                overflow: "hidden",
                wordBreak: "break-word",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: horizontal ? 1 : "unset",
                WebkitBoxOrient: "vertical",
                [$theme.mediaQuery.medium]: {
                  WebkitLineClamp: 1,
                },
              }),
            },
          }}
        >
          {title}
        </H4>
      )}
      <Paragraph4
        overrides={{
          Block: {
            style: ({ $theme }) => ({
              whiteSpace: "normal",
              overflow: "hidden",
              wordBreak: "break-word",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              fontFamily: "True Text A",
              WebkitLineClamp: fullHeight ? 3 : 2,
              WebkitBoxOrient: "vertical",
              letterSpacing: ".3px",
              fontSize: fullHeight ? "1.2em" : "1.25em",
              lineHeight: fullHeight ? "1.2em" : "1.25em",
              minHeight: fullHeight ? "3.5em" : "2.56em",
              maxHeight: fullHeight ? "3.5em" : "auto",
              [$theme.mediaQuery.medium]: {
                fontSize: fullHeight ? "1.25em" : "1.25em",
                lineHeight: fullHeight ? "1.28em" : "1.28em",
                minHeight: fullHeight ? "3.95em" : "2.56em",
                maxHeight: fullHeight ? "3.95em" : "auto",
              },
              [$theme.mediaQuery.large]: {
                fontSize: fullHeight ? "1.3em" : "1.25em",
                lineHeight: fullHeight ? "1.25em" : "1.28em",
                minHeight: fullHeight ? "3.75em" : "2.56em",
                maxHeight: fullHeight ? "3.75em" : "2.56em",
              },
            }),
          },
        }}
        marginTop={"0px"}
        marginBottom={"0px"}
        color={"#E0E0E0"}
      >
        {fullHeight && (
          <span
            style={{
              fontSize: ".75em",
              letterSpacing: "-0.6px",
              fontFamily: "True Bold",
            }}
          >
            {title}{" "}
          </span>
        )}{" "}
        {description}
      </Paragraph4>
    </>
  )
}

const PostCard = ({
  post,
  horizontal = false,
  fullHeight = false,
  imgCover = false,
  marginBottom,
  marginTop,
  inBlock = false,
  showOne = false,
}: any) => {
  const coverImage = formatMessageFromData(post, "imageCover")
  return (
    <Block
      flex={1}
      to={`/post/${post.id}`}
      as={Link}
      className={"post-card"}
      display={horizontal ? "flex" : "block"}
      backgroundColor={"#1C1C1C"}
      width={"100%"}
      height={"auto"}
      position={"relative"}
      overrides={{
        Block: {
          style: ({ $theme }) => ({
            textDecoration: "none",
            borderRadius: "4px",
            boxShadow: $theme.lighting.shadow400,
          }),
        },
      }}
      overflow={"hidden"}
      marginTop={marginTop}
      marginBottom={marginBottom}
    >
      {horizontal ? (
        <Block
          overflow={"hidden"}
          flex={1}
          position={"relative"}
          width={"100%"}
          height={"auto"}
          paddingBottom={
            inBlock
              ? ["23.5%", "0px", "0px", "0px"]
              : showOne
              ? "30.5%"
              : "23.5%"
          }
        >
          <Block
            as={"img"}
            $style={{
              objectFit: imgCover ? "cover" : "unset",
              objectPosition: "top",
            }}
            src={coverImage}
          />
        </Block>
      ) : (
        <div className={`post-img ${fullHeight ? "full-height" : ""}`}>
          <Block
            as={"img"}
            src={
              fullHeight && post.imageCoverPortrait
                ? post.imageCoverPortrait
                : post.imageCover
            }
            $style={{
              objectFit: imgCover ? "cover" : "unset",
              objectPosition: "top",
            }}
          />
        </div>
      )}
      <Block
        height={"auto"}
        flex={horizontal ? (showOne ? 0.8 : [1.3, 1.1, 1.4, 1.4]) : 1}
      >
        <Block
          paddingTop={horizontal ? ["8px", "8px", "8px", "20px"] : "15px"}
          paddingBottom={horizontal ? ["8px", "8px", "8px", "20px"] : "20px"}
          paddingLeft={["10px", "10px", "19px", "19px"]}
          paddingRight={["10px", "10px", "19px", "19px"]}
        >
          <PostDescription
            title={formatMessageFromData(post, "title")}
            description={formatMessageFromData(post, "shortDescription")}
            fullHeight={fullHeight}
            horizontal={horizontal}
          />
        </Block>
      </Block>
    </Block>
  )
}

export default PostCard
